// LIVE 2.0 — single source for how a live event's status is shown in the admin.
// The coordinator writes the granular broadcast status to `live_v2_status` on every
// lifecycle transition (scheduled → starting_soon → live → interrupted/drop_grace → ended).
// The admin displays THAT (not the manual `event_type`), so the status shown in the
// content catalog and the Live Schedule is driven only by the v2 live lifecycle and stays
// in sync. Falls back to `event_type` when there is no v2 status yet (e.g. a YouTube-only
// event, or a CF event the coordinator hasn't reconciled yet).

const V2_LABEL = {
  scheduled: 'Upcoming',
  starting_soon: 'Starting Soon',
  live: 'Live Now',
  interrupted: 'Interrupted',
  drop_grace: 'Ending',
  ended: 'Ended',
  needs_operator: 'Needs Operator',
}

// Coarse class reused by the existing badge CSS (upcoming | live | completed).
const V2_CLASS = {
  scheduled: 'upcoming',
  starting_soon: 'upcoming',
  live: 'live',
  interrupted: 'live',
  drop_grace: 'live',
  ended: 'completed',
  needs_operator: 'upcoming',
}

const EVENT_TYPE_LABEL = { upcoming: 'Upcoming', live: 'Live Now', completed: 'Completed' }

export function liveStatusLabel(liveV2Status, eventType) {
  if (liveV2Status && V2_LABEL[liveV2Status]) return V2_LABEL[liveV2Status]
  return EVENT_TYPE_LABEL[eventType] || eventType || 'Upcoming'
}

export function liveStatusClass(liveV2Status, eventType) {
  if (liveV2Status && V2_CLASS[liveV2Status]) return V2_CLASS[liveV2Status]
  return eventType || 'upcoming'
}

// True when the event is on air right now (live or a transient hold), by v2 status.
export function isLiveNow(liveV2Status) {
  return ['live', 'interrupted', 'drop_grace'].includes(liveV2Status)
}
